import React, { useMemo } from 'react';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { ProductOldNewPriceNameplate } from './product-old-new-price-nameplate';
import {
  oldPriceContainer,
  container,
  oldPriceWrap,
  oldCurrencyWrap,
  padLeft,
  padRight,
  primaryPriceFractCurrencyWrap,
  newOldPriceStyle,
  mainPriceWrap,
  specialPriceContainer,
  bestPriceStyle,
  specialOldPriceWrap,
  mainLargePriceWrap,
  smallPriceWrap,
  primaryLargePriceFractCurrencyWrap,
  oldSmallPriceAndCurrencyWrap,
} from './styles';
import { ProductBestPriceNameplate } from './product-best-price-nameplate';

type ProductOldNewPriceProps = {
  hintShown?: boolean;
  currency: string;
  priceFirst: string;
  priceSecond?: string | null;
  rawOldPrice: string;
  hasOldPrice: boolean;
  hasBestPrice: boolean;
  uom?: string;
  isSmallFontSize?: boolean;
};

export const ProductSpecialPrice: React.FC<ProductOldNewPriceProps> = ({
  uom,
  priceFirst,
  priceSecond,
  rawOldPrice,
  currency,
  hasOldPrice,
  hasBestPrice,
  isSmallFontSize = false,
}) => {
  const oldPrice = useMemo(() => {
    return rawOldPrice.slice(0, rawOldPrice.indexOf('₽'));
  }, [rawOldPrice]);

  const formattedOldPriceString = useMemo(
    () => (oldPrice.slice(-4) === ',00\u00A0' ? `${oldPrice.slice(0, -4)}\u00A0` : oldPrice),
    [oldPrice]
  );

  const priceFirstWithComma = `${priceFirst},`;
  const specialPriceColor = hasBestPrice ? bestPriceStyle : newOldPriceStyle;

  return (
    <div data-qa={hasBestPrice ? 'product-best-price' : 'product-old-new-price'} className={container}>
      {hasBestPrice ? <ProductBestPriceNameplate /> : <ProductOldNewPriceNameplate />}
      <div className={specialOldPriceWrap}>
        {hasOldPrice && (
          <div className={cx(oldPriceContainer)}>
            <Typography
              variant="s"
              size="body_accent"
              className={cx(oldPriceWrap, isSmallFontSize ? oldSmallPriceAndCurrencyWrap : '')}>
              {formattedOldPriceString}
            </Typography>
            <Typography
              variant="s"
              size="body_accent"
              className={cx(oldCurrencyWrap, isSmallFontSize ? oldSmallPriceAndCurrencyWrap : '')}>
              {currency}
            </Typography>
          </div>
        )}
        <div className={specialPriceContainer}>
          <span
            className={cx(
              mainPriceWrap,
              isSmallFontSize ? smallPriceWrap : mainLargePriceWrap,
              specialPriceColor
            )}
            data-qa={hasBestPrice ? 'best-price-main' : 'new-price-main'}>
            {priceSecond ? priceFirstWithComma : priceFirst}
          </span>
          {priceSecond && (
            <span
              className={cx(
                primaryPriceFractCurrencyWrap,
                isSmallFontSize ? smallPriceWrap : primaryLargePriceFractCurrencyWrap,
                specialPriceColor,
                padLeft
              )}
              data-qa={hasBestPrice ? 'best-price-fract' : 'new-price-fract'}>
              {priceSecond}
            </span>
          )}
          <span
            className={cx(
              primaryPriceFractCurrencyWrap,
              isSmallFontSize ? smallPriceWrap : primaryLargePriceFractCurrencyWrap,
              specialPriceColor,
              padRight,
              padLeft
            )}>
            {`${currency}${uom ? `/${uom}` : ''}`}
          </span>
        </div>
      </div>
    </div>
  );
};
